// extracted by mini-css-extract-plugin
export default {"wrapper":"Kn-z","viewport":"Ln-z","container":"Mn-z","slide":"Nn-z"};